import { useQuery } from '@tanstack/react-query'
import type { AccountsAdminApi } from '../adminApi.js'
import { formatDateTime, Skeleton } from '../../core/index.js'

/** The admin calls this screen uses. */
type AdminApi = AccountsAdminApi

const SHOWN = 8
const ROLE_LABEL = { operator: 'operator', facility_administrator: 'facility administrator', worker: 'worker' } as const

/** Who has opened this demo client as whom, newest first: the record behind the "Open as…" menu. */
export function DemoSessionsList({ api, clientId }: { api: AdminApi; clientId: string }) {
  const query = useQuery({ queryKey: ['admin', 'demo-sessions', clientId], queryFn: () => api.listDemoSessions(clientId) })
  if (query.isPending) {
    return <Skeleton />
  }
  if (query.isError) {
    return <div className="text-[11px] text-ink-mid">This API does not record demo sessions yet.</div>
  }
  if (query.data.length === 0) {
    return <div className="text-[11px] text-ink-mid">Nobody has opened this demo as one of its people yet.</div>
  }
  return (
    <ul className="text-[11px] text-ink divide-y divide-marine/10 bg-white border border-marine/15">
      {query.data.slice(0, SHOWN).map((session) => (
        <li key={session.sessionId} className="px-3 py-1.5 flex flex-wrap justify-between gap-x-3">
          <span>
            <span className="font-bold">{session.subjectName ?? session.subject}</span> <span className="text-ink-mid">({ROLE_LABEL[session.as]})</span>
            <span className="text-ink-mid"> · opened by {session.openedBy}</span>
          </span>
          <span className="text-ink-mid whitespace-nowrap">{formatDateTime(session.openedAt)}</span>
        </li>
      ))}
      {query.data.length > SHOWN && <li className="px-3 py-1.5 text-ink-mid">and {query.data.length - SHOWN} earlier</li>}
    </ul>
  )
}
